import { LogoutOutlined } from '@ant-design/icons';
import { Button, Drawer, Layout, Modal } from 'antd';
import styled from 'styled-components';

const { Sider } = Layout;

export const SiderDesktop = styled(Sider)`
  display: none;
  
  @media screen and (min-width: 992px) {
    display: block;
  }

  .expanded-logo {
    display: inline;
    margin-left: 20px;
  }

  .closed-logo {
    display: none;
  }

  &.ant-layout-sider-collapsed .closed-logo {
    display: inline;
  }

  &.ant-layout-sider-collapsed .expanded-logo {
    display: none;
  }

  .ant-menu {
    padding: 0;
  }

  .ant-menu-item {
    padding: 0 20px !important;
    margin: 16px 0 0 0 !important;
    position: relative;
    background: none !important;
    width: 100%;
    .anticon {
      display: flex !important;
      align-items: center;
      height: 40px;
      font-size: 20px !important;
      position: relative;
    }
    .ant-menu-title-content {
      position: relative;
      font-size: 16px;
    }
    &:before {
      content: '';
      position: absolute;
      display: block;
      background: rgba(18, 223, 169, 0);
      border-radius: 8px;
      top: 0;
      left: 10px;
      right: 10px;
      bottom: 0;
      transition: all 0.3s ease;
    }
    &.ant-menu-item-active {
      .anticon,
      .ant-menu-title-content {
        color: #12dfa9 !important;
      }
    }
    &:hover {
      .anticon,
      .ant-menu-title-content {
        color: #ffffff !important;
      }
    }
    &:hover:before {
      background: rgba(18, 223, 169, 0.2);
    }
  }
`;

export const ButtonCollapsed = styled.span`
  position: absolute;
  bottom: 10px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.65);
  left: 10px;
  padding: 0;
  line-height: 1;
  display: flex;
  width: 40px;
  gap: 8px;
  font-size: 16px;
  align-items: center;
  height: 40px;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  .anticon {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.65);
  }
  &.open {
    width: 140px;
    justify-content: flex-start;
    left: 10px;
    padding: 0 10px;
  }
  &:hover {
    background: rgba(18, 223, 169, 0.2);
    color: #ffffff;
    .anticon {
      color: #ffffff;
    }
  }
`;

export const Header = styled(Layout.Header)`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  /*box-shadow: inset 0px -1px 0px #f0f0f0;*/
  position: sticky;
  top: 0;
  z-index: 5;
  color: #000000;
  background: #f5f5f5;
`;

export const LogoSidebarInv360 = styled.span`
  font-size: 0;
  padding: 20px 0;
  background: #0a0e25;
  display: flex;
  line-height: 32px;
  flex-direction: row;
  align-items: center;

  &.collapsed {
    flex-direction: column;
  }

  .beta {
    color: var(--primary-6);
    text-align: center;
    font-size: 10px;
    font-style: italic;
    font-weight: 500;
    line-height: 10px;
    letter-spacing: -0.4px;
    margin-left: 5px;
  }

  &.collapsed {
    .beta {
      margin-top: 5px;
      margin-left: 0px;
    }
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const PageTitle = styled.span`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
`;

export const AvatarContainer = styled.div`
  padding-right: 16px;
  margin-right: 8px;
  font-size: 14px;
  border-right: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  &.is-super-admin {
    padding-right: 8px;
  }

  span.super_admin {
    position: absolute;
    top: -5px;
    right: 3px;
    border-radius: 50%;
    background: var(--primary-color);
    color: #000;
    height: 18px;
    width: 18px;
    z-index: 2;
    line-height: 15px;
    text-align: center;
    padding-top: 1px;
    font-size: 14px;
  }
`;

export const UserControls = styled.span`
  display: flex;
  align-items: center;
  .ant-btn-group.ant-dropdown-button {
    margin: 20px 0 0;
  }
`;

export const Logout = styled(LogoutOutlined)`
  font-size: 14px;
`;

export const MenuMobile = styled(Button)`
  margin: 3px 8px 0 -8px;
  color: #000000;
  @media screen and (min-width: 992px) {
    display: none;
  }
`;

export const AvatarText = styled.div`
  p {
    margin: 0;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  span {
    margin: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    display: block;
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const MobileSidebar = styled(Drawer)`
  .ant-drawer-header {
    flex-direction: row-reverse;
    background: #0a0e25;
    border-radius: 0;
    padding: 23px 16px 21px;

    .ant-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
      flex-grow: 1;

      span {
        padding: 0;
      }

      button {
        margin: 0;
        color: #ffffff;
      }
    }
  }
  .ant-btn {
    padding: 0;
    width: 100%;
    text-align: left;
  }
  ${AvatarContainer} {
    border: none;
    padding: 0;
    margin: 0;
  }
`;

export const FooterSidebarMobile = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 300px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  background: #f0f0f0;
  .ant-btn {
    width: auto;
    text-align: center;
  }
`;

export const AccountSelectorContainer = styled.div`
  padding: 8px 11px;
  cursor: pointer;

  div.account-selector-border {
    background: #272936;
    border-radius: 5px;
    color: #fff;
    padding: 8px 8px 8px 0;
    display: flex;
    align-items: center;
    font-size: 1rem;

    &.empty {
      padding: 7px 4px;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 8px;
    }
  }

  @media screen and (max-width: 992px) {
    padding: 8px 8px;

    div {
      background: transparent;
      color: #000;
    }
  }
`;

export const AccountSelectorModal = styled(Modal)`
  .ant-list-item-meta-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 55px;
    margin-inline-end: 0;
  }
`;

export const AvatarCustom = styled.img`
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 4px;
  margin-left: 9px;
  margin-right: 11px;

  @media screen and (max-width: 992px) {
    width: 14px;
    height: 14px;
  }
`;
